import { cleanObject, cloneDeep } from '../utils';

export default {
	methods: {
		updateUrl(value) {
			const query = cleanObject({
				tab: this.$route.query.tab,
				...cloneDeep(value),
			});
			this.$router.push({ query }).catch(() => {});
		},
	},
};
